export const EXPORT_TRADES_PERMISSION = 'export:trades'
export const READ_USERS_PERMISSION = 'read:users'
export const CREATE_USERS_PERMISSION = 'create:users'

import { useMemo } from 'react'
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

interface DecodedToken {
  permissions?: string[]
}

export function useHasPermission(permission: string): boolean {
  const token = Cookies.get('access_token')

  return useMemo(() => {
    if (!token) return false
    try {
      const decoded = jwtDecode<DecodedToken>(token)
      return decoded.permissions?.includes(permission) ?? false
    } catch (e) {
      console.warn('[useHasPermission] Failed to decode access token:', e)
      return false
    }
  }, [token, permission])
}
